import { style } from "@vanilla-extract/css";
import {
  primitiveTokens,
  semanticThemeTokens
} from "../../theme/ThemeTokens.css";

export const appErrorPage = style({
  minHeight: "100%",
  alignContent: "center",
  width: "100%"
});

export const appErrorPageWithBackground = style({
  background: semanticThemeTokens.loginPage.background,
  backgroundBlendMode: "multiply, normal",
  minHeight: "100vh",
  alignContent: "center",
  width: "100%"
});

export const appErrorMainContent = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
});

export const appErrorContentContainer = style({
  display: "flex",
  maxWidth: "640px",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  gap: primitiveTokens.sizing["6x"],
  padding: primitiveTokens.sizing["4x"]
});

export const logoContainer = style({
  maxHeight: "48px"
});

export const copyrightText = style({
  color: semanticThemeTokens.loginPage.copyRight.color,
  textAlign: "center",
  fontSize: primitiveTokens.type.xs,
  fontStyle: "normal",
  letterSpacing: "-0.24px",
  padding: `${primitiveTokens.sizing["2x"]} ${primitiveTokens.sizing["4x"]}`
});
